import { createContext } from "react";

/** When non-null, useFeatureFlags reads from this context instead of useUserProfile. */
const FeatureFlagsContext = createContext<Map<string, boolean> | null>(null);

export default FeatureFlagsContext;
